import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, Transition as _Transition, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-7969630b"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
    key: 0,
    class: "list-detail-drawer__list-section__list"
};
const _hoisted_2 = {
    key: 1,
    class: "component-candidate-list"
};
const _hoisted_3 = { class: "no-results--wrapper" };
const _hoisted_4 = ["src"];
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", null, "No options found. Check your filters.", -1 /* HOISTED */));
const _hoisted_6 = {
    key: 2,
    class: "component-candidate-list"
};
const _hoisted_7 = ["onClick"];
const _hoisted_8 = { class: "group-header" };
const _hoisted_9 = { class: "header-content" };
const _hoisted_10 = { key: 0 };
const _hoisted_11 = { key: 0 };
const _hoisted_12 = ["onClick"];
import { isEmpty } from "lodash";
import noSearchResultsImage from "assets/extole-report-no-reports-found.png";
import NotificationFlash from "../../ui/NotificationFlash.vue";
import ComponentDisplayName from "../ComponentDisplayName.vue";
import ComponentCandidatePath from "./ComponentCandidatePath.vue";
import CampaignName from "./CampaignName.vue";
import { ref, watch } from "vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ComponentCandidateList',
    props: {
        components: {},
        selectedComponentId: {},
        isLoading: { type: Boolean }
    },
    emits: ["update:selectedComponentId"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const collapsedGroups = ref({});
        const expandedGroupId = ref(null);
        const getComponentGroupUniqueId = (component) => `${component.name}-${component.type}`;
        const groupComponents = (components) => {
            const componentGroups = [];
            components.forEach((component) => {
                const uniqueId = getComponentGroupUniqueId(component);
                const existingGroup = componentGroups.find((group) => group.uniqueId === uniqueId);
                if (existingGroup) {
                    existingGroup.components.push(component);
                }
                else {
                    if (!(uniqueId in collapsedGroups.value)) {
                        collapsedGroups.value = Object.assign(Object.assign({}, collapsedGroups.value), { [uniqueId]: true });
                    }
                    componentGroups.push({
                        uniqueId,
                        name: component.name,
                        displayName: component.getDisplayName(),
                        description: component.description,
                        components: [component],
                    });
                }
            });
            return componentGroups.sort((a, b) => a.displayName.toLowerCase().localeCompare(b.displayName.toLowerCase()));
        };
        const toggleGroup = (groupId) => {
            if (expandedGroupId.value === groupId) {
                expandedGroupId.value = null;
            }
            else {
                expandedGroupId.value = groupId;
            }
        };
        const selectFirstComponent = (group) => {
            if (group.components.length > 0) {
                emit("update:selectedComponentId", group.components[0].id);
                expandedGroupId.value = group.uniqueId;
            }
        };
        const expandGroupForComponent = (componentId) => {
            if (!componentId)
                return;
            const groups = groupComponents(props.components);
            const group = groups.find((group) => group.components.some((component) => component.id === componentId));
            if (group) {
                expandedGroupId.value = group.uniqueId;
            }
        };
        const handleGroupHeaderClick = (group) => {
            if (group.components.length === 1) {
                emit("update:selectedComponentId", group.components[0].id);
            }
            else {
                if (expandedGroupId.value === group.uniqueId) {
                    expandedGroupId.value = null;
                }
                else {
                    selectFirstComponent(group);
                }
            }
        };
        watch(() => props.selectedComponentId, (newId) => {
            expandGroupForComponent(newId);
        });
        return (_ctx, _cache) => {
            return (_ctx.isLoading)
                ? (_openBlock(), _createElementBlock("ul", _hoisted_1, [
                    _createElementVNode("li", null, [
                        _createElementVNode("p", null, [
                            _createVNode(NotificationFlash)
                        ])
                    ])
                ]))
                : (_unref(isEmpty)(_ctx.components))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("img", { src: _unref(noSearchResultsImage) }, null, 8 /* PROPS */, _hoisted_4),
                            _hoisted_5
                        ])
                    ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groupComponents(_ctx.components), (group) => {
                            return (_openBlock(), _createElementBlock("div", {
                                key: group.uniqueId,
                                class: "component-group"
                            }, [
                                _createElementVNode("div", {
                                    class: _normalizeClass(["group-content", {
                                            'single-item': group.components.length === 1,
                                            selected: group.components.length === 1 &&
                                                group.components[0].id === _ctx.selectedComponentId,
                                        }]),
                                    onClick: ($event) => (handleGroupHeaderClick(group))
                                }, [
                                    _createElementVNode("div", _hoisted_8, [
                                        _createElementVNode("div", _hoisted_9, [
                                            _createElementVNode("h3", null, _toDisplayString(group.displayName), 1 /* TEXT */),
                                            (group.components.length === 1)
                                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                    _createVNode(CampaignName, {
                                                        "campaign-id": group.components[0].campaign_id
                                                    }, null, 8 /* PROPS */, ["campaign-id"]),
                                                    _createVNode(ComponentCandidatePath, {
                                                        "component-id": group.components[0].id
                                                    }, null, 8 /* PROPS */, ["component-id"])
                                                ], 64 /* STABLE_FRAGMENT */))
                                                : _createCommentVNode("v-if", true)
                                        ]),
                                        (group.components.length > 1)
                                            ? (_openBlock(), _createElementBlock("i", {
                                                key: 0,
                                                class: _normalizeClass(["fas", {
                                                        'fa-chevron-down': expandedGroupId.value !== group.uniqueId,
                                                        'fa-chevron-up': expandedGroupId.value === group.uniqueId,
                                                    }])
                                            }, null, 2 /* CLASS */))
                                            : _createCommentVNode("v-if", true)
                                    ]),
                                    (group.description)
                                        ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(group.description), 1 /* TEXT */))
                                        : _createCommentVNode("v-if", true)
                                ], 10 /* CLASS, PROPS */, _hoisted_7),
                                _createVNode(_Transition, { name: "slide" }, {
                                    default: _withCtx(() => [
                                        (group.components.length > 1 &&
                                            expandedGroupId.value === group.uniqueId)
                                            ? (_openBlock(), _createElementBlock("ul", _hoisted_11, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.components, (component) => {
                                                    return (_openBlock(), _createElementBlock("li", {
                                                        key: component.id,
                                                        onClick: ($event) => (emit('update:selectedComponentId', component.id)),
                                                        class: _normalizeClass({
                                                            active: _ctx.selectedComponentId === component.id,
                                                        })
                                                    }, [
                                                        _createVNode(ComponentDisplayName, {
                                                            "component-id": component.id,
                                                            "tag-name": 'h3'
                                                        }, null, 8 /* PROPS */, ["component-id"]),
                                                        _createVNode(CampaignName, {
                                                            "campaign-id": component.campaign_id
                                                        }, null, 8 /* PROPS */, ["campaign-id"]),
                                                        _createVNode(ComponentCandidatePath, {
                                                            "component-id": component.id
                                                        }, null, 8 /* PROPS */, ["component-id"])
                                                    ], 10 /* CLASS, PROPS */, _hoisted_12));
                                                }), 128 /* KEYED_FRAGMENT */))
                                            ]))
                                            : _createCommentVNode("v-if", true)
                                    ]),
                                    _: 2 /* DYNAMIC */
                                }, 1024 /* DYNAMIC_SLOTS */)
                            ]));
                        }), 128 /* KEYED_FRAGMENT */))
                    ]));
        };
    }
});
